<template>
    <transition name="modal" v-if="isActive">
        <perfect-scrollbar class="modal-mask">
            <div class="modal-customer-store modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4>
                            <b-icon icon="pencil-square"></b-icon>
                            <span>ค้นหาลูกค้าร้านค้า</span>
                        </h4>

                        <button class="btn-close" @click="hide()"><b-icon icon="x"></b-icon></button>
                    </div>
                    <div class="modal-body">
                        <div class="form">
                            <div class="row">
                                <div class="col-12">
                                    <div class="field">
                                        <div class="gadget-search-box">
                                            <b-icon icon="search"></b-icon>
                                            <input type="text" placeholder="ชื่อร้าน / ทะเบียนรถ / ชื่อลูกค้า" maxlength="50" v-model="formFilter.keyword" />
                                            <button class="btn btn-main" @click="loadCustomerStoreList()">ค้นหา</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <loader-spinner :isDisplay="isLoading" class="mt-4 mb-4"></loader-spinner>

                        <template v-if="!isStartSearch">
                            <div class="filter">
                                <div class="no-data">
                                    <b-icon icon="chat-right-dots"></b-icon>
                                    <span>หากเป็นร้านค้าใหม่โปรดกด "เป็นลูกค้าร้านค้าใหม่" หรือค้นหาชื่อร้านที่มีอยู่ในระบบ</span>
                                    <button class="btn btn-main" @click="selectCustomerStore(null)">ลูกค้าร้านค้าใหม่</button>
                                </div>
                            </div>
                        </template>

                        <div class="mt-3" v-if="isShowResult">
                            <template v-if="searchResult.length > 0">
                                <perfect-scrollbar>
                                    <table>
                                        <thead>
                                            <tr>
                                                <th>ชื่อร้าน</th>
                                                <th>ที่อยู่</th>
                                                <th>ผู้ติดต่อ</th>
                                                <th></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(item, index) in searchResult" :key="index">
                                                <td>
                                                    {{ item.name }}
                                                    <span>เลขประจำตัวผู้เสียภาษี: {{ item.taxId }} </span>
                                                </td>
                                                <td>{{ item.address }}</td>
                                                <td>
                                                    <span class="main">{{ item.contactPerson }}</span>
                                                    <span><b-icon icon="telephone" class="icon"></b-icon> {{ item.contactTel }}</span>
                                                </td>
                                                <td><div class="text-center"><button class="btn btn-sm btn-blue text-nowrap" @click="selectCustomerStore(item.data)">เลือก</button></div></td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </perfect-scrollbar>

                                <paging @page="changePage($event)" :activePage="activePage" :pageSize="pageSize" :contentLength="searchResult.length" class="mt-4"></paging>
                            </template>

                            <template v-if="isStartSearch && searchResult.length === 0">
                                <div class="filter">
                                    <div class="no-data">
                                        <b-icon icon="exclamation-diamond"></b-icon>
                                        <span>ไม่พบร้านค้าที่กำลังค้นหาในประวัติลูกค้าร้านค้า กรณีเป็นลูกค้าร้านค้าใหม่โปรดปุ่มด้านล่าง</span>
                                        <button class="btn btn-main" @click="selectCustomerStore(null)">ลูกค้าร้านค้าใหม่</button>
                                    </div>
                                </div>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </perfect-scrollbar>
    </transition>
</template>

<script>
import ModelKeywordFilter from '@/resources/models/KeywordFilter';
import DBCustomerStore from '@/database/CustomerStore';

export default {
    data() {
        return {
            isActive: false,
            isShowResult: false,
            isLoading: false,
            formFilter: ModelKeywordFilter.data(),
            searchResult: [],
            isStartSearch: false,
            activePage: 1,
            pageSize: 10
        };
    },
    props: {
        isDisplay: Boolean
    },
    watch: {
        isDisplay(value) {
            this.isActive = value;
            this.$root.$emit('rootSetContentScrollable', !value);

            if (value) {
                this.isStartSearch = false;
            }
        }
    },
    methods: {
        hide() {
            this.$emit('hide', null);
        },
        filterResult(result) {
            if (this.formFilter.keyword) {
                result = result.filter(x => x.name?.toLowerCase().indexOf(this.formFilter.keyword.toLowerCase()) > -1 
                                            || x.taxId?.toLowerCase().indexOf(this.formFilter.keyword.toLowerCase()) > -1
                                            || x.contactPerson?.toLowerCase().indexOf(this.formFilter.keyword.toLowerCase()) > -1
                                            || x.contactTel?.toLowerCase().indexOf(this.formFilter.keywor.toLowerCase()) > -1);
            }

            return result;
        },
        async loadCustomerStoreList() {
            this.isShowResult = false;
            this.isLoading = true;
            this.isStartSearch = true;
            this.searchResult = [];

            const result = await DBCustomerStore.get();

            if (result.content && result.content.length > 0) {
                // Filter Result
                result.content = this.filterResult(result.content);

                // Map and Place into the Object
                this.searchResult = this.mapViewData(result.content);
            }

            // Done Search
            this.isLoading = false;
            this.isShowResult = true;
        },
        mapViewData(content) {
            const data = [];

            content.forEach((item) => {
                data.push({
                    taxId: item.taxId,
                    name: item.name,
                    address: [ item.address, item.subDistrict, item.district, item.province, item.postCode ].join(' '),
                    contactPerson: item.contactPerson,
                    contactTel: item.contactTel,
                    data: item
                });
            });

            return data;
        },
        selectCustomerStore(item) {
            this.$emit('hide', item);
        },
        changePage(value) {
            this.activePage = value;
        }
    }
}
</script>

<style lang="scss" scoped>
.modal-customer-store {
    max-width: 1000px;

    table {
        font-size: 13px;

        td {
            vertical-align: top;
        }
    }
}
</style>